import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styled from './index.module.scss';
import { isStatusB } from '../../pageStatus';

export default function Comp() {
    const { t } = useLang('BannerA');

    const { locale } = getLocal();

    const imagePC = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753671879987/kv-pc.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756779042314-5o23b5-compressed-%E5%85%A8%E7%B3%BB%E5%88%97Lifestyle%20KV.jpg';

    const imagePad = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753671853045/kv-pad.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756779388782-cwq5i2-compressed-%E5%85%A8%E7%B3%BB%E5%88%97Lifestyle%20KV.jpg';

    const imageH5 = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753671852819/kv-h5.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756780555946-6atiex-compressed-%E5%85%A8%E7%B3%BB%E5%88%97Lifestyle%20KV2%202.jpg';

    const lHrefMap = {
        us: 'https://us.ecoflow.com/products/trail-series',
        ca: 'https://ca.ecoflow.com/products/trail-series',
        eu: 'https://eu.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        uk: 'https://uk.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        de: 'https://de.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        fr: 'https://fr.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        it: 'https://it.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        es: 'https://es.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        ph: 'https://ph.ecoflow.com/products/trail-series',
    };
    const youtobeLinkMap = {
        us: 'https://www.youtube.com/embed/QpN97jUrOD8?si=0WgY3lp1DJLqnTzy',
        ca: 'https://www.youtube.com/embed/QpN97jUrOD8?si=0WgY3lp1DJLqnTzy',
        eu: 'https://www.youtube.com/embed/FIGwqr8do9I',
        uk: 'https://www.youtube.com/embed/FIGwqr8do9I',
        de: 'https://www.youtube.com/embed/GzIFxYAmwsQ',
        fr: 'https://www.youtube.com/embed/rumeROuHA2U',
        it: 'https://www.youtube.com/embed/fZSP3spTgQQ',
        es: 'https://www.youtube.com/embed/Xf-h7V6xgYw',
        ph: 'https://www.youtube.com/embed/QpN97jUrOD8?si=0WgY3lp1DJLqnTzy',
    };

    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: imagePC,
        pad: imagePad,
        h5: imageH5,
        // label: t('label'),
        // labelColor: '#D11504',
        title: t('title'),
        desc: t('desc'),

        // 按钮
        lType: 'filled',
        lChildren: t('btn1'),
        lHref: isStatusB() ? lHrefMap[locale as keyof typeof lHrefMap] : '',
        lBtnIsYouToBe: false,
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'buy',
            product_name: t('title'),
            position: 'Product Detail_1',
            __btn_id1: `${styled.banner} .__btn_l`,
            __btn_id2: isStatusB() ? lHrefMap[locale as keyof typeof lHrefMap] : '',
            __btn_type: 'href',
        },

        // 按钮
        rType: 'outlined',
        rChildren: t('btn2'),
        rHref: youtobeLinkMap[locale as keyof typeof youtobeLinkMap] || youtobeLinkMap['us'],
        rBtnIsYouToBe: true,
        rDataLayer: {
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('title'),
            position: 'Product Detail_1',
            __btn_id1: `${styled.banner} .__btn_r`,
            __btn_id2: 'bannerBtnR',
            __btn_type: 'common',
        },
    };
    return (
        <div id="banner" className={`${styled.banner} GtmModuleData-section`} data-section-id={'BannerA'}>
            <EcoBanner theme="white" {...dataA} />
            <div className="footer-desc eco-content">{t('footer_desc')}</div>
        </div>
    );
}
